import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../app.service';
import { DigitalFormService } from '../digital-form-fill/digital-form.service';
import { DigitalFormDataVM, DigitalFormQuestionsCategoriesVM } from '../favourite-dialog/favourite-dialog-modal';
import { DFIInspectionReportVM } from '../setup-implement/setup-implement.model';

@Component({
  selector: 'app-digital-form-reports',
  templateUrl: './digital-form-reports.component.html',
  styleUrls: ['./digital-form-reports.component.scss']
})
export class DigitalFormReportsComponent implements OnInit {

  uploadId:number
  formId:number
  formQSections : DigitalFormQuestionsCategoriesVM[]=[];
  DigtalFormOverview:DigitalFormDataVM;
  InputCategoryName:string
  FormSectionDetails:DFIInspectionReportVM[]=[]
  //appUris: AppUris;

  constructor(
    public _formService: DigitalFormService,
    private _route: ActivatedRoute,
    private _toaster:NotificationsService,
    private _appService: AppService,
  
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('DFI Report Options');
    this.uploadId = +this._route.snapshot.paramMap.get('uploadId');
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    this.formId=+this._route.snapshot.paramMap.get('formId');
    if(this.formId>0 && this.uploadId>0){
      this.LoadFormUploadDetails();
    }
  }


  LoadFormUploadDetails(){

    this._formService.GetDFIInspectionReportSections(this.uploadId).subscribe(res=>{
      this.FormSectionDetails=res
    })
  }

  GroupTypeNameChanged(QuesCatID, name){
console.log(QuesCatID, name)
this._formService.DFIReportUpdateCategoryName(this.uploadId,QuesCatID,name).subscribe(r=>{
  if (r==true) {
    this._toaster.success("Saved");
  } else {
    this._toaster.error("Error");
  }
})
  }


  toggleIncludeBody(QuesCatID: number) {   
    if (QuesCatID > 0) {
      this._formService.DFIReportInspectionIncludeBody(this.uploadId,QuesCatID).subscribe(r => {
        if (r==true) {
          this._toaster.success("Saved");
        } else {
          this._toaster.error("Error");
        }
      });
    }
  }
  
  toggleIncludeTable(QuesCatID){
    if (QuesCatID > 0) {
      this._formService.DFIReportInspectionIncludeDataTable(this.uploadId,QuesCatID).subscribe(r => {
        if (r==true) {
          this._toaster.success("Saved");
        } else {
          this._toaster.error("Error");
        }
      });
    }
  }

recalculateSortOrderDown(GroupOrder){
this._formService.DFIReportUpdateSectionCategoryOrderDown(this.uploadId, GroupOrder).subscribe(res=>{
  this.LoadFormUploadDetails()

})
  }

  recalculateSortOrderUp(GroupOrder){
    this._formService.DFIReportUpdateSectionCategoryOrderUp(this.uploadId, GroupOrder).subscribe(res=>{
      this.LoadFormUploadDetails()
    })
      }

  GetPdfDigitalForm(){
    //window.open(this.appUris.UCUri + 'api/DigitalFormIdentity/GetPdFDFIReports?FormUploadID=' + this.uploadId, '_blank');
    window.open(this._appService.getBaseURL() + 'api/DigitalFormIdentity/GetPdFDFIReports?FormUploadID=' + this.uploadId, '_blank');
  }
  getTekerikReport(){
    window.open(this._appService.getBaseURL() + 'api/DigitalFormIdentity/GetDigitalFormInspectionPdf?FormUploadID=' + this.uploadId , '_blank');
  }
}